/**
 * Panel boczny na jedną sprawę o budynku — dziś wysyłka do osady.
 *
 * **Miejsce zależy od tego, skąd go otwarto.** Z panelu pola staje **na lewo
 * od niego** (`beside`), bo jest dalszym ciągiem tej samej rozmowy o budynku,
 * na którym się stoi. Z menu pod prawym przyciskiem staje **przy samej
 * krawędzi** (`edge`) — a panel pola na ten czas schodzi, bo dotyczy innego
 * pola i zasłoniłby go. Tę samą zasadę stosuje `StorePanel`.
 *
 * **Na dole zawsze „zamknij”**, jak w każdym panelu bocznym: to jest wyjście
 * z akcji, a nie tylko schowanie okna.
 */

export type SidePlace = 'edge' | 'beside';

export class SideSheet {
  private readonly root = document.createElement('div');
  private readonly title = document.createElement('div');
  private readonly body = document.createElement('div');

  constructor(
    container: HTMLElement,
    private readonly onClose: () => void
  ) {
    this.root.className = 'store';
    this.root.hidden = true;
    this.root.addEventListener('contextmenu', (event) => event.preventDefault());

    this.title.className = 'store-title';
    this.body.className = 'store-list';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'side-close';
    close.textContent = 'zamknij';
    close.addEventListener('click', () => this.onClose());

    this.root.append(this.title, this.body, close);
    container.appendChild(this.root);
  }

  get open(): boolean {
    return !this.root.hidden;
  }

  show(title: string, content: HTMLElement, place: SidePlace): void {
    this.title.textContent = title;
    this.body.replaceChildren(content);
    this.root.classList.toggle('store-beside', place === 'beside');
    this.root.hidden = false;
  }

  /** Przestawia otwarty panel — np. do krawędzi, gdy panel pola zniknął. */
  place(place: SidePlace): void {
    this.root.classList.toggle('store-beside', place === 'beside');
  }

  hide(): void {
    this.root.hidden = true;
    this.body.replaceChildren();
  }

  dispose(): void {
    this.root.remove();
  }
}
